import { useQuery } from '@apollo/client';

import { GET_LE_GROUP_FOR_FIRST_FITTING } from '../../graphql/profile/queries';
import {
  LEGroupForFirstFittingResponse,
} from '../../graphql/profile/models/get-le-group-for-first-fitting.models';

export const useLEGroupForFirstFitting = (isEnabled: boolean): string | null => {
  const { data } = useQuery<LEGroupForFirstFittingResponse>(
    GET_LE_GROUP_FOR_FIRST_FITTING,
    { skip: !isEnabled },
  );

  return data?.profile?.groupLECodeForFirstFitting ?? null;
};
